import * as React from 'react';
// import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { AntdConfigProvider, IntlProvider, RouteTree, PermissionContext } from '@/components';
import store from '@/stores/index';

const App = observer(() => {

  React.useEffect(() => {
    const app: any = document.querySelector('.app');
    app.dataset.lang = store.locale;
  }, [store.locale]);

  return (
    <AntdConfigProvider locale={store.locale} >
      <IntlProvider locale={store.locale}>
        <PermissionContext.Provider value={{
          routePermission: store.menuList,
          pageElementPermission: store.pageElements,
          isChildAccount: store.config?.isChildAccount,
        }}>
          <RouteTree />
        </PermissionContext.Provider>
      </IntlProvider>
    </AntdConfigProvider>
  );
});

export default App;
